import React from 'react';
import CommunityOverviewPage from './CommunityOverviewPage';
import BusinessOverviewPage from './BusinessOverviewPage';

export default function LandingPage(): JSX.Element {
  return process.env.REACT_APP_APPLICATION_VERSION === 'BUSINESS' ? (
    <BusinessOverviewPage />
  ) : (
    <CommunityOverviewPage />
  );
}
